declare global {
  interface Window {
    umami?: { track: (name: string, data?: Record<string, string | number | boolean>) => void };
  }
}

export type ConversionEvent =
  | "cta_start_project"
  | "cta_explore_solutions"
  | "cta_talk_to_engineer"
  | "inquiry_submit_started"
  | "inquiry_submit_success"
  | "inquiry_submit_error"
  | "contact_click"
  | "phone_click"
  | "email_click";

export function trackConversion(name: ConversionEvent, data: Record<string, string | number | boolean> = {}) {
  if (typeof window === "undefined") return;
  window.umami?.track(name, data);
  window.dispatchEvent(new CustomEvent("quantum-maps:conversion", { detail: { name, ...data } }));
}
